const types = {
    LOGIN: 'LOGIN',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGOUT: 'LOGOUT',
    LOGIN_FAILED: 'LOGIN_FAILED',
    SET_ME: 'SET_ME'
}

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutation-types.js